export default "__VITE_ASSET__tC5fLTrQ__";